import { Link } from "react-router-dom";
// import './CollectionCard.css';

const ItemCard = ({item}) => {
    
    return(
        <Link to = {`/itemdetails/${item.name}`} className="collection_card px-4 py-3 flex flex-col items-center justify-center rounded-[10px] pb-3 shadow dark:border-gray-800 dark:bg-dark-card border-[1px]">
            <p className="w-full mb-3 text-sm lg:text-base xl:text-lg text-slate-500 dark:text-gray-300">
                {item.collection}
            </p>
            <div className="image_box w-full h-full max-w-[800px] max-h-[800px] mb-5">
                <img src = {item.image} alt = {item.name} className = "w-full h-full object-cover image_content rounded-t-[10px]" />
            </div>
            <div className="w-full dark:text-white">
                <h3 className="text-base lg:text-lg xl:text-xl font-bold">{item.name}</h3>
            </div>
            <div className="w-full">
                <p className="w-full text-sm lg:text-base xl:text-lg text-slate-500 dark:text-gray-300">
                    Price: <span className = "font-bold text-main ">0.0003 ETH</span> 
                </p>
            </div>
        </Link>
    )
}

export default ItemCard;